import { FournisseurItemDto } from './fournisseur-item-dto';

export class FournisseurListDto
{
    fournisseurDtoList: FournisseurItemDto[];
    requestId:String;
}